import axios from 'axios';
import router from '../router'
import reduxStore from '../store';

let API_URL;
if (location.hostname == 'app.shipsen.com' || location.hostname == 'ivorycoast.shipsen.com') {
    API_URL = "https://api.shipsen.com";
} else if(location.hostname == "old.shipsen.com") { 
    API_URL = "https://api2.shipsen.com";
}else if(location.hostname == "senegal.shipsen.com") { 
    API_URL = "https://api3senegal.shipsen.com";
}else if(location.hostname == "shipsen.speedliv.com") { 
    API_URL = "https://api-shipsen.speedliv.com";
}
else{
    //API_URL = "http://" + "167.71.1.17" + ":3030/api";
     API_URL = "http://" + "localhost"+":3030/api";
    
}

const token = window.localStorage.getItem("id_token");

const HTTP = axios.create({
    baseURL: API_URL,
    headers: {
        'X-Auth-Token': token
    }
})

HTTP.interceptors.response.use(function (response) {
    // Do something with response data
    
    if(response.data && response.data.status == 401 && token){
        window.localStorage.removeItem('id_token');
        window.location.href = '/';
    }else if(response.data && response.data.status == 400 && token){
       alert(response.data.content);
    }else{

        const fe_headers = response.headers;
       // console.log('fe_headers name----',fe_headers)
        if(token && response.data && response.data.content && response.config && response.config.method && fe_headers && reduxStore.state && reduxStore.state.user && reduxStore.state.user.email){
            const fe_version = fe_headers['pragma'] || '1';
            if(fe_headers['cache-control']){
                 //console.log('-------------header-------------',fe_headers['cache-control'])
                 var properties = fe_headers['cache-control'].split(',');
                 var myobjData = {};
                 if( typeof properties === 'object'){
                    properties.forEach(function(property) {
                        var tup = property.split(':');
                        myobjData[tup[0]] = tup[1];
                    });
                 }
               //  console.log('-------------myobjData-------------',myobjData)
                if(myobjData && myobjData.isUpdate && myobjData.isUpdate =='true' && myobjData.userId && myobjData.userId.toString() ===  reduxStore.state.user._id.toString() || (fe_version !== localStorage.getItem('pr-version'))){
                    console.log('-------------data changet this user-------------');
                    reduxStore.dispatch("actionupdate",{update:true,pr_version:fe_version});
                }
            }
        }

        if(router && router.history.current.name && window.localStorage.getItem("id_token") && response.data && response.data.content && reduxStore.state && reduxStore.state.user && reduxStore.state.user.email  && router.history  && router.history.current && router.history.current.name &&  router.history.current.name!='profile' && router.history.current.name!='newUser' && router.history.current.name!='multiWarehouses' && router.history.current.name!='updateUser' && (reduxStore.state.user.status!='active'  || (reduxStore.state.user.type=="Seller" && (!reduxStore.state.user.rib || !reduxStore.state.user.fullName)))){
           console.log('route name----',router.history.current.name)
          // console.log('email name----',response.data.content)
           if(reduxStore.state.user.type == 'Courier' || router.history._startLocation.includes('subscribers')) return response;
           else window.location.href = '/profil';
        }else{
            //console.log('router-----',router.history.current.name)
           // console.log('response-----',response)
            //return response;
            // console.log('token-----',window.localStorage.getItem("id_token"))
            // console.log('response-----',response)
            // console.log('response data-----',response.data.content)
            if(window.localStorage.getItem("id_token") && response.data && response.data.content && reduxStore.state && reduxStore.state.user && reduxStore.state.user.email && router.history && router.history.current && router.history.current.name && router.history.current.name!='errorPage'){
                if(reduxStore.state.user.role && reduxStore.state.user.role.access_pages.length>0) {
               //  console.log('users/me-----',response.config.url)
               //  return false
                //    console.log('router.history.current.name data-----',router.history.current.name)
                //    console.log('pages-----',response.data.content.role)
                //    console.log('check acess-----',response.data.content.role.access_pages.indexOf(router.history.current.name))
                //    console.log('data  conten user-----',response.data.content)
                  // return false
                   //Check ip user

                    if(reduxStore.state.user.role.access_pages.indexOf(router.history.current.name) !== -1)  return response;
                    else {
                        //console.log('url-------------',response.config.url)
                        // return false;
                        if((router.history.current.name === 'multiWarehouses' && response.config.url === 'users/me') || router.history.current.name!='multiWarehouses') {
                           if(router.history.current.name === 'updateUser')  return response;
                           else {window.location.href = '/error-page';}
                        }else return response;
                     }
                }else return response;
            }else return response;
        }    
    }
  }, function (error) {
    // Do something with response error
    return Promise.reject(error);
  });

export default HTTP
